module.exports = __webpack_public_path__ + "bc85853dbdcb266098d88c67e8b6ac86.pdf";